export default "__VITE_ASSET__4E8CMfJv__"